/**
 * VMDetectionController is a class that manages the detection of virtual machines (VMs)
 * and handles user interactions related to VM detection.
 * 
 * @class
 * @param {Object} $scope - AngularJS scope object.
 * @param {Object} EventLogBridgeService - Service for logging events.
 * @param {Object} BridgeRuntimeService - Service for managing runtime operations.
 * @param {Object} LogBridgeService - Service for logging messages.
 * @param {Object} $uibModal - AngularUI Bootstrap modal service.
 * @param {Object} VMDetectionService - Service for detecting virtual machines.
 * @param {Object} $location - AngularJS $location service for URL manipulation.
 */
class VMDetectionController {
    constructor($scope, EventLogBridgeService, BridgeRuntimeService, LogBridgeService, $uibModal, VMDetectionService, $location) {
        this.$scope = $scope;
        this.EventLogBridgeService = EventLogBridgeService;
        this.BridgeRuntimeService = BridgeRuntimeService;
        this.LogBridgeService = LogBridgeService;
        this.$uibModal = $uibModal;
        this.VMDetectionService = VMDetectionService;
        this.$location = $location;

        // Controller meta setup
        this.$scope._logIdentifier = 'VMDetectionController';

        // Initialize the logger
        this.$logger = this.LogBridgeService;

        // Configuration for the modal dialog
        this.modalConfig = {
            templateUrl: "/views/ib/modules/vm-detection/InvigilatorModal.html",
            windowClass: "quit-compcheck-modal",
            transclude: false,
            backdrop: 'static',
            controller: 'VMDetectionInvigilatorModal',
            resolve: {}
        };

        // Bind methods to the controller instance
        this.$scope.invigilatorLogin = this.invigilatorLogin.bind(this);
        this.$scope.onButtonQuitClick = this.onButtonQuitClick.bind(this);

        // Check if a VM is detected
        if (!this.VMDetectionService.isDetected()) {
            this.$logger.info("VM-Detection: no VM detected");
            this.$location.path("/login");
        }
    }

    /**
     * Opens the invigilator login modal dialog.
     * 
     * @method
     */
    invigilatorLogin() {
        this.$uibModal.open(this.modalConfig);
    }

    /**
     * Handles the click event for the quit button.
     * 
     * @method
     */
    onButtonQuitClick() {
        this.BridgeRuntimeService.quit(false);
    }
}

export default VMDetectionController;